import { Grid } from '@mui/material';
import React, {useEffect, useState} from 'react';
import { connect } from 'react-redux';
import {
    CompanyInfoSection, 
} from '../components/forms/company';
import { ScreenHeader } from '../components/screenHeader';
import {getCompany, setCompany, updateCompany} from '../app/slices/companiesSlice';
import {
    fetchComplains,
    previousPage,
    nextPage,
    resetFilter,
    setFilter,
    checkItem,
    checkAllItems,
    uncheckItem,
    uncheckAllItems,
} from "../app/slices/complainsSlice";
import { withRouter } from '../wrappers/withRouter';
import {LAYOUT_CONFIG} from "../layoutConfig";
import {useParams} from "react-router-dom";
import CompanyInfoForm from "../components/forms/newCompany/companyInfoForm";
import CompanyAdditionalInfoForm from "../components/forms/newCompany/companyAdditionalInfoForm";
import CompanySectorsSection from "../components/forms/newCompany/companySectorsSection";
import CompanyScoreSection from "../components/forms/newCompany/companyScoreSection";
import CompanyService from "../components/services/CompanyService";
import CompanyComplainsList from "../components/forms/newCompany/companyComplainsList";


const CompanyEditArrowScreen = ({filter, selectedItems}) => {
    const [open, setOpen] = useState(null);
    const [company, setCompanyModel] = useState(null);
    const {id} = useParams();

    useEffect(() => {
        if(id) {
            fetchCompany(id);
        }
    }, [id]);

    const onFieldChange = (fieldName, value) => {
        setCompanyModel(prev => {
            return {
                ...prev,
                [fieldName]: value,
            }
        })
    }

    const onFieldSave = async (fieldName, value) => {
        const data = { id, fieldName: fieldName, value };
        await update(id, data);
    }

    const update = async (companyId, data) => {
        await CompanyService.update(companyId, data);
    }
    
    const fetchCompany = (companyId) => {
        CompanyService.getById(companyId).then(response => {
            setCompanyModel(response.data);
        })
    }

    const handleRefresh = () => {
        fetchCompany(id);
    }

    const refresh = async () => {
        fetchCompany(company.id);
    };

    const refreshComplains = async () => {
        await fetchComplains({ companyId: id });
    };

    const handleFieldSave = async (field, value) => {
        await updateCompany({ id, fieldName: field, value });
        refresh();
    };

    const handlePreviousPage = () => {
        previousPage();
        refreshComplains();
    };

    const handleNextPage = () => {
        nextPage();
        refreshComplains();
    };

    const handleRequestSort = (event, property) => {
        const direction = filter.orderBy === property && filter.orderDirection === "asc" ? "desc" : "asc";
        setFilter({ field: "orderBy", value: property });
        setFilter({ field: "orderDirection", value: direction });

        refreshComplains();
    };

    const handleRowCheck = (item, isChecked) => {
        if (!isChecked) {
            checkItem(item);
        } else {
            uncheckItem(item);
        }
    };

    const handleSelectAll = () => {
        // if (selectedItems.length === complains.length) {
        //     uncheckAllItems();
        // } else {
        //     checkAllItems();
        // }
    };

    const handleRowClick = (id) => {
        setOpen(prev => (prev === id ? null : id));
    };
    
    if(!company) {
        return null;
    }
    
    return (
        <div className="fk-screen">
            <ScreenHeader
                withBackButton
                withSeparator
                navigateBackRoute={"../companies"}
                title="companyHeader"
                titleReplacement={['#COMPANY_NAME#', company.name]}
                subtitle="companySubheader"
                subtitleReplacement={['#COMPANY_ID#', company.id]}
            />
            <Grid container spacing={4}>
                <Grid item md={6}>
                    
                    <CompanyInfoForm 
                        canEdit 
                        model={company} 
                        onFieldChange={onFieldChange} 
                        onFieldSave={onFieldSave}
                    />
                    
                    {company?.sectorsData?.length <= 1 &&
                        <CompanyAdditionalInfoForm 
                            canEdit 
                            model={company} 
                            onFieldChange={onFieldChange} 
                            onFieldSave={onFieldSave} />
                    }
                </Grid>
                <Grid item md={6}>
                    {company?.id && <CompanyInfoSection onRefresh={refresh} model={company}/>}
                    {LAYOUT_CONFIG.COMPANY_DETAILS.SHOW_POINTS &&
                        <CompanyScoreSection 
                            onChange={onFieldChange}
                            onSave={onFieldSave}
                            model={company}
                        />
                    }
                </Grid>
                {company?.sectorsData?.length > 0 &&
                    <Grid item md={12}>
                        <CompanySectorsSection sectorsData={company.sectorsData} onUpdate={handleRefresh}/>
                    </Grid>
                }
            </Grid>
            <CompanyComplainsList
                companyId={company.id}
                selectedItems={selectedItems}
                onRequestSort={handleRequestSort}
                onRowCheck={handleRowCheck}
                onSelectAll={handleSelectAll}
                onPreviousPage={handlePreviousPage}
                onNextPage={handleNextPage}
            />
        </div>
    )

}

const mapStateToProps = (state) => ({
    model: state.companies.company,
    complains: state.complains.data,
    filter: state.complains.filter,
    selectedItems: state.complains.selectedItems,
});

const actions = {
    fetchComplains,
    previousPage,
    nextPage,
    resetFilter,
    setFilter,
    checkItem,
    checkAllItems,
    uncheckItem,
    uncheckAllItems,
    getCompany,
    updateCompany,
};

export default withRouter(connect(mapStateToProps, actions)(CompanyEditArrowScreen));